import { QueryClient, QueryClientProvider } from "react-query"
import ApiKeys from "./ApiKeys";

const queryClient = new QueryClient();

const ZapierApiKeys = () => {
  return <QueryClientProvider client={queryClient}>
    <ApiKeys />
  </QueryClientProvider>
}
export default ZapierApiKeys
